<template>
    <loading :active="loading"
             :can-cancel="true"
             :on-cancel="onCancel"
             :is-full-page="fullPage"></loading>

    <div>
        <div align="center" style="margin:10px 0;">
            <span class="btn"><input type="button" onclick="history.back();" :value="i18n.myoffice.Golist"></span>
        </div>
        <div id="order_left">
            <div class="edit-info">
                <h1 class="edit-info-caption">{{ i18n.myoffice.Order.orderInformation }}</h1>
                <ul>
                    <li>
                        <div class="edit-info-subject">{{ i18n.myoffice.Order.ordno }}</div>
                        <div class="edit-info-content">
                            <strong>{{ row.ord_no }}</strong>
                            <span v-if="row.ord_kind2">[{{row.ord_kind2}}]</span>
                            <span v-html="row.acc_dates"></span>
                        </div>
                    </li>
                    <li v-if="bp_row.ord_no">
                        <div class="edit-info-subject">{{ i18n.myoffice.Order.basicOrderno }}</div><!-- 원(原) 구매번호 -->
                        <div class="edit-info-content"><strong onclick="view_ord_info('{{ bp_row.ord_no }}');">{{ bp_row.ord_no }}</strong> &nbsp;
                            <div v-if="bp_row.rcpt_yn == 'Y'">
                                {{ i18n.myoffice.Order.Paymentdate }} : {{ row.acc_date }}
                            </div>
                            <div v-else>
                                {{ i18n.myoffice.Order.undeposit }}
                            </div>
                        </div> <!-- 결제일 --><!-- 미결제 입니다. -->
                    </li>
                    <li>
                        <div class="edit-info-subject">{{ i18n.myoffice.Order.type }}</div>
                        <div class="edit-info-content">{{ row.kind_cd == "1" ? "Order" : "Auto Order" }}</div>
                    </li>
                    <li>
                        <div class="edit-info-subject">{{ i18n.myoffice.Order.amount }}</div>
                        <div class="edit-info-content"><span id="item_customer">{{ i18n.myoffice.currency }}{{ formatPrice(row.ord_amt,2) }}</span> ,&nbsp;&nbsp; <span id="item_bv">{{ formatPrice(row.ord_pv,1) }} PV</span></div> <!-- 원 몰수당 원 -->
                    </li>
                    <li>
                        <div class="edit-info-subject">{{ i18n.myoffice.Order.depositamount }}</div>
                        <div class="edit-info-content"><span id="item_customer">{{ i18n.myoffice.currency }}{{ formatPrice(row.rcpt_total,2) }}</span> ,&nbsp;&nbsp; [{{ row.rcpt_yn=='Y' ? (row.ord_kind == "0" ?  i18n.myoffice.CancleComplete : i18n.myoffice.paymentComplete ) : i18n.myoffice.Order.undeposit }}] </div><!-- 취소완료 : '결제완료 : 미입금 -->
                    </li>

                    <li>
                        <div class="edit-info-subject">{{ i18n.myoffice.Order.invoicenumber }}</div>
                        <div class="edit-info-content">
                            <div v-if="deli_mst.send_date">
                                {{ deli_mst.deli_no }}, &nbsp;<b> {{ deli_mst.deli_kinds }} &nbsp;</b>
                            </div>
                            <div v-else>
                                {{ i18n.myoffice.Order.UnRelease }}
                            </div>
<!--                                    @if(deli_mst.deli_kind == 1)-->
<!--                                        {{ i18n.myoffice.Order.Cdirectreceipt }}-->
<!--                                    @elseif(deli_mst.deli_kind == 3)-->
<!--                                        {{ i18n.myoffice.Order.FreightCollect }}-->
<!--                                    @else-->
<!--                                        {{ i18n.myoffice.Order.FreightPrepaid }}-->
<!--                                    @endif-->
                        </div><!--출고일:  미출고 / --><!-- 출고일 -->
                    </li>
                </ul>

                <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <table id="pdt-list" class="relative border-collapse	border border-slate-400 overflow-x-auto shadow-md sm:rounded-lg" cellspacing="0" width="100%">
                        <thead>
                        <tr>
                            <th class="px-6 py-3 whitespace-nowrap border border-slate-300">No</th>
                            <th class="px-6 py-3 whitespace-nowrap border border-slate-300">{{ i18n.shop.autoshipse2.pdt_code }}</th>
                            <th class="px-6 py-3 whitespace-nowrap border border-slate-300">{{ i18n.myoffice.Order.pdtName }}</th>
                            <th class="px-6 py-3 whitespace-nowrap border border-slate-300">{{ i18n.myoffice.Order.qty }}</th>
                            <th class="px-6 py-3 whitespace-nowrap border border-slate-300">PV</th>
                            <th class="px-6 py-3 whitespace-nowrap border border-slate-300">{{ i18n.myoffice.Order.amount }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(value, index) in pdt_list">
                            <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">{{ index+1 }}</td>
                            <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">
                                <a href="#" onclick="winBomList('reg_bom_list_'+value.pdt_cd, this);return false;">{{ value.pdt_cd }}</a>
                            </td>
                            <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">{{ value.pdt_name }}</td>
                            <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300 text-center">{{ value.qty }}</td>
                            <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300 text-right">{{ formatPrice(value.pv * value.qty,1) }}</td>
                            <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300 text-right">{{ formatPrice(value.price * value.qty,2) }}</td>
                        </tr>
                        <tr>
                          <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300"></td>
                          <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300 text-center" colspan="2">
                            Item(s) Subtotal
                          </td>
                          <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300 text-center">{{ sumQty }}</td>
                          <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300 text-right">{{ formatPrice(sumPv,1) }}</td>
                          <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300 text-right">{{ formatPrice(sumAmount,2) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>


            <div v-if="row.ord_kind != 0 && row.rcpt_yn == 'Y' && isOwnDelivery" class="info_alert_div flex items-center justify-between" style="margin-top: 15px">
                <span class='btn info'><input type='button' v-on:click="popup_invoice(row.ord_no);" :value="i18n.myoffice.Order.purchaseform"></span><!-- 상품구매계약서 -->

                  <table class="detail-price-info relative w-1/3 border-collapse	 overflow-x-auto shadow-md sm:rounded-lg" >
                    <tr class="bg-gray">
                      <td  class="border-b-2 border-black-small text-right">Item(s) Subtotal</td>
                      <td  class="border-b-2 border-black-small text-right">${{formatPrice(row.ord_price,2)}}</td>
                    </tr>
                    <tr class="bg-gray">
                      <td class="border-b-2 border-black-small text-right">Shipping Total</td>
                      <td v-if="ord_deli_list && Object.keys(ord_deli_list).length > 0" class="border-b-2 border-black-small text-right">
                          ${{ formatPrice(parseFloat(ord_deli_list['shipping']['price']) + parseFloat(ord_deli_list['signature']['price']) + parseFloat(ord_deli_list['insurance']['price']),2) }}
                      </td>
                      <td v-else class="border-b-2 border-black-small text-right">
                          ${{formatPrice(row.deli_amt,2)}}
                      </td>
                    </tr>

                    <tr v-if="ord_deli_list['signature']['price'] > 0" class="text-sm text-right pt-4">
                        <td class="border-b-2 border-slate-300 text-right">Signature</td>
                        <td class="border-b-2 border-slate-300 text-right">${{ formatPrice(ord_deli_list['signature']['price'],2) }}</td>
                    </tr>
                      <tr v-else class="text-sm text-right pt-4">
                          <td class="border-b-2 border-slate-300 text-right">Ground</td>
                          <td class="border-b-2 border-slate-300 text-right">${{ formatPrice(ord_deli_list['shipping']['price'],2) }}</td>
                      </tr>
                    <tr v-if="ord_deli_list['insurance']['price'] > 0" class="text-sm text-right ">
                        <td class="border-b-2 border-slate-300 text-right">Insurance</td>
                        <td class="border-b-2 border-slate-300 text-right">${{ formatPrice(ord_deli_list['insurance']['price'],2) }}</td>
                    </tr>
                    <tr v-if="ord_deli_list['direct_shipping']['price'] > 0" class="text-sm text-right ">
                      <td class="border-b-2 border-slate-300 text-right">Direct shipping</td>
                      <td class="border-b-2 border-slate-300 text-right">${{ formatPrice(ord_deli_list['direct_shipping']['price'],2) }}</td>
                    </tr>
<!--                    <template v-if="service_list.length > 0">-->
<!--                      <template v-for="(service, index) in service_list">-->
<!--                        <tr>-->
<!--                          <td class="border-b-2 border-slate-300 text-right">{{ service.pdt_name }}</td>-->
<!--                          <td class="border-b-2 border-slate-300 text-right">${{ formatPrice(service.amt, 2) }}</td>-->
<!--                        </tr>-->
<!--                      </template>-->
<!--                    </template>-->
                    <tr class="bg-gray">
                      <td class="border-b-2 border-black-small text-right">Tax</td>
                      <td class="border-b-2 border-black-small text-right">${{ formatPrice(ord_sum_amt['total_vat'],2) }}</td>
                    </tr>
                    <tr class="bg-gray">
                      <td class="border-b-2 border-black-small text-right">Total</td>
                      <td class="border-b-2 border-black-small text-right">${{formatPrice(row.ord_amt,2)}}</td>
                    </tr>
                  </table>
            </div>

        </div>

        <div id="order_right">
            <div class="edit-info">
                <h1 class="edit-info-caption">{{ i18n.myoffice.Order.PaymentDetails }}</h1>
                <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <table id="rcpt-list" class="relative border-collapse	border border-slate-400 overflow-x-auto shadow-md sm:rounded-lg" cellspacing="0" width="100%">
                        <thead>
                        <tr>
                            <th class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">No</th>
                            <th class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">{{ i18n.myoffice.Order.PaymentType }}</th><!-- 결제유형 -->
                            <th class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">{{ i18n.myoffice.Order.Approvalnumber }}</th><!-- 승인번호 -->
                            <th class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">{{ i18n.myoffice.Order.amount }}</th><!-- 총금액 -->
                            <th class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">{{ i18n.myoffice.dashboard.date }}</th><!-- 날짜 -->
                            <th class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">{{ i18n.myoffice.remarks }}</th><!-- 비고 -->
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(value,index) in rcpt_list">
                            <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300 text-center">{{ index+1 }}</td>
                            <!-- 지페스타 상품은 전표버튼 노출안되게 수정 -->
                            <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300 text-center">{{ value.kinds }}</td><!-- 전표 -->
                            <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300 text-center">{{ value.card_app_no }}</td>
                            <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300 text-right">${{ formatPrice(value.amt,2) }}</td>
                            <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300 text-center">{{ value.reg_date }}</td>
                            <td class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">{{ value.remark }} <span v-if="row.ord_kind == '0'" class="text-red-600">( {{ i18n.myoffice.Order.Cancel }} )</span></td><!-- [취소] -->
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-if="row.kind_Cd !=7 && isOwnDelivery" class="logis edit-info" id="logis_right">
            <h1 class="edit-info-caption">{{ i18n.myoffice.Order.shippinginformation }}</h1>
            <ul>
                <li>
                    <div class="edit-info-subject">{{ i18n.myoffice.Order.Deliverymethod }}</div>
                    <div class="edit-info-content doc-link-box">
                       {{ ord_deli.deli_kinds }}
                    </div>
                </li>
                <li>
                    <div class="edit-info-subject">{{ i18n.myoffice.Address }}</div>
                    <div class="edit-info-content">{{ ord_deli.addr }} {{ ord_deli.r_post }}</div>
                </li>
                <li>
                    <div class="edit-info-subject">{{ i18n.myoffice.Order.Recipient }}</div>
                    <div class="edit-info-content">{{ ord_deli.r_name }}&nbsp;</div>
                </li>
                <li>
                    <div class="edit-info-subject">{{ i18n.myoffice.Order.Contact }}</div>
                    <div class="edit-info-content">{{ ord_deli.r_mobile }}&nbsp;</div>
                </li>
                <li>
                    <div class="edit-info-subject">{{ i18n.myoffice.Order.Shippingnotes  }}</div><!-- 배송메모 -->
                    <div class="edit-info-content">{{ ord_deli.r_memo }}&nbsp;</div>
                </li>
            </ul>
        </div>

        <div v-for="( value,index ) in deli_mst"  v-if="row.kind_Cd !=7 && isOwnDelivery" class="logis edit-info" id="logis_right">
            <ul>
                <li>
                    <div class="edit-info-subject">{{ i18n.myoffice.Order.Issuenumber }}</div>
                    <div class="edit-info-content doc-link-box">
                        <b>{{ value.deli_no }}</b>&nbsp;
                        <span v-if="value.send_date == ''">{{ i18n.myoffice.Order.UnRelease }}</span>
                        <span v-if="value.i_list"> {{ i18n.myoffice.Order.shippingnumber }}:
                            <span v-for="( ivalue,iindex ) in value.i_list" style="color:#09C; font-weight: bold;">{{ ivalue }}</span>&nbsp;
                            <span class="btn info">
                                <a v-for="( ivalue,iindex ) in value.i_list" href="#" v-on:click='viewTraking(ivalue)'>{{ i18n.myoffice.Order.trackingNumber }}</a>
                            </span>
                        </span>
                    </div>
                </li>
            </ul>
            <div class="relative overflow-x-auto shadow-md sm:rounded-lg" v-if="false">
                <table  id="deli_pdt-list-{{value.deli_no}}" class="relative border-collapse	border border-slate-400 overflow-x-auto shadow-md sm:rounded-lg" cellspacing="0" width="100%">
                    <thead>
                    <tr>
                        <th class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">No</th>
                        <th class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">PID</th>
                        <th class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">{{ i18n.myoffice.Order.pdtName}}</th><!-- 제품명 -->
                        <th class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">{{ i18n.myoffice.Order.qty}}</th><!-- 수량 -->
                        <th class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">PV</th>
                        <th class="px-6 py-3 w-3 whitespace-nowrap border border-slate-300">{{ i18n.myoffice.Order.amount}}</th><!-- 총금액 -->
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="( pdt_val,pdt_index ) in value.deli_pdt_list">
                        <td class="px-6 py-3 w-3 whitespace-nowrap text-center border border-slate-300">{{ pdt_index+1 }}</td>
                        <td class="px-6 py-3 w-3 whitespace-nowrap text-center border border-slate-300">{{ pdt_val.pdt_cd }}</td>
                        <td class="px-6 py-3 w-3 whitespace-nowrap text-left border border-slate-300">{{ pdt_val.pdt_name }}</td>
                        <td class="px-6 py-3 w-3 whitespace-nowrap text-right border border-slate-300">{{ pdt_val.qty }}</td>
                        <td class="px-6 py-3 w-3 whitespace-nowrap text-right border border-slate-300">{{ formatPrice(pdt_val.pv * pdt_val.qty,1) }}</td>
                        <td class="px-6 py-3 w-3 whitespace-nowrap text-right border border-slate-300">{{ formatPrice(pdt_val.amt * pdt_val.qty,2) }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div style="clear:both;"></div>
        <br><br>
        <div align="center" style="margin:10px 0;">
            <span class="btn"><input type="button" onclick="history.back();" :value="i18n.myoffice.Golist"></span><!-- 목록으로 -->
        </div>
    </div>
    <modalView v-if="showModal" @close-modal="showModal = false" :harf="false">
        <invoice :deli_no="deli_no" ref="invoice"></invoice>
    </modalView>

</template>

<script>
import modalView from "../../modalView.vue";
import invoice from "../../invoice/invoice";

export default {
    name: "MyOrderView",
    components : {
        modalView,
        invoice
    },
    props: ['no'],
    data: () => ({
      i18n : window.i18n,
        row : "",
        bp_row : "",
        deli_mst : "",
        rcpt_list : "",
        isOwnDelivery : false,
        mst : "",
        pdt_list_temp : "",
        pdt_list : [],
        sumQty : 0,
        sumPv : 0,
        sumAmount : 0,
        ord_deli : "",
        loading : false,
        fullPage : true,
        showModal: false,
        deli_no : "",
        service_list : [],
        ord_sum_amt : [],
        ord_deli_list : []
    }),
    created : function (){
        this.submitForm();
    },
    methods : {
        submitForm: function (event) {
            this.loading = true;
            axios.post(window.Laravel.back_url+'/api/getMyOrderView', {
                ord_no: this.no
            }, {headers: {Authorization: 'Bearer ' + window.Laravel.access_token}}).then(response => {
                this.loading = false;
                this.row = response.data.row;
                this.isOwnDelivery = response.data.isOwnDelivery;
                this.pdt_list_temp = response.data.pdt_list;

                this.ord_sum_amt = response.data.ordSumAmt;
                this.ord_deli_list = response.data.ordDeliList;

                this.pdt_list_temp.forEach((value, index) => {
                  // Signature(000243) 금액의 경우, 수정 시점 전에는 ord_pdt에서는 배송비와 합산되어 있기 때문에 deli2_amt 기준으로 책정
                  const amt          = value.pdt_cd === '000243' ? response.data.row.deli2_amt : value.amt;
                  const serviceTotal = this.serviceTotal(response.data.service_list, value.pdt_cd, amt);
                  // if(value.pdt_cd != '000240'){
                  if(!serviceTotal) {
                    this.pdt_list.push(value);
                    this.sumQty     = this.sumQty +  Number(value.qty);
                    this.sumPv     = this.sumPv + (value.pv * value.qty);
                    this.sumAmount = this.sumAmount + (value.price * value.qty);
                  }
                });

                this.ord_deli = response.data.ord_deli;

                const temp = this.ord_deli.r_addr1.split("|@|");
                const temp2 = this.ord_deli.r_addr2.split("|@|");
                this.ord_deli.addr = temp2[0] +', '+ temp2[1]+', ' + temp[0] +', '+  temp[1];//주소체계 미국순
                this.rcpt_list = response.data.rcpt_list;
                this.deli_mst = response.data.deli_mst;
            });

        },
        popup_invoice(ord_no) {
            window.open(window.Laravel.back_url+"/api/getInvoice?ordno="+ord_no);
        },
        viewTraking(invoice_no){
            //this.deli_no = deli_no;
            //this.showModal = true;
            window.open("http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums="+invoice_no);
        },
        formatPrice(value,digit) {
            let val = (value/1).toFixed(digit).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
      // 주문 시 추가된 서비스 요금 000240% (배송비, TAX는 따로 표기 하므로 제외)
       serviceTotal(service_list = [], pdt_cd = '', amt = 0) {
           if (!pdt_cd || (pdt_cd === '000240') || (pdt_cd === '000241')) { // 배송비, TAX는 따로 표기
             return true;
           }
           const serviceObj = service_list.find(data => data.pdt_cd === pdt_cd);
           let flag         = false;
           if(serviceObj && amt > 0) {
             this.service_list.push({'pdt_cd' : serviceObj.pdt_cd, 'pdt_name': serviceObj.pdt_name, 'amt': amt});
             flag = true;
           }
          return flag;
       }

    }

}
</script>

<style scoped>
    .detail-price-info tr {
        line-height: 1.7;
    }
    .bg-gray {
        background-color: #eee;
        font-weight: 500;
    }
</style>
